<template>
    <div v-html="html"></div>
</template>

<script>
//   import { videoPay } from '@/api/pay.js'
  export default {
    data(){
      return{
        html:''
      }
    },
    methods:{
      fetchVideoPay(){
        let param={
          orderNumber: this.$route.query.orderId
        };
        // 请求支付宝支付接口
        this.$HTTP.executePost(this.$APIS.ALIPAY_PAY, param, this)
        .then( res => {
          this.html = res.data;
          this.$nextTick(() => {
            document.forms[0].submit()
          })
        })
      }
    },
    mounted(){
      this.fetchVideoPay()
    }
  }
</script>